import React from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

const renderValue = (value) => {
  if (value === undefined || value === null || value === "") {
    return "—";
  }

  return value;
};

export default function ResponsiveEntityCard({
  title,
  subtitle,
  media,
  chips,
  selectionControl,
  fields = [],
  footer,
  actions,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "16px",
        borderColor: "#E4E4E4",
        boxShadow: "0 8px 24px rgba(17, 20, 45, 0.06)",
      }}
    >
      <CardContent sx={{ p: 2.25 }}>
        <Stack spacing={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.5,
                minWidth: 0,
                flexGrow: 1,
              }}
            >
              {selectionControl ? (
                <Box sx={{ pt: 0.25, flexShrink: 0 }}>{selectionControl}</Box>
              ) : null}

              {media ? <Box sx={{ flexShrink: 0 }}>{media}</Box> : null}

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    color: "#11142D",
                    fontSize: "1rem",
                    fontWeight: 700,
                    lineHeight: 1.4,
                    wordBreak: "break-word",
                  }}
                >
                  {renderValue(title)}
                </Typography>

                {subtitle ? (
                  <Typography
                    sx={{
                      color: "#808191",
                      fontSize: "0.875rem",
                      lineHeight: 1.5,
                      mt: 0.5,
                      wordBreak: "break-word",
                    }}
                  >
                    {subtitle}
                  </Typography>
                ) : null}
              </Box>
            </Box>

            {chips ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  gap: 1,
                  flexShrink: 0,
                }}
              >
                {chips}
              </Box>
            ) : null}
          </Box>

          {fields.length ? (
            <Grid container spacing={1.5}>
              {fields.map((field) => (
                <Grid item xs={12} sm={field.fullWidth ? 12 : 6} key={field.label}>
                  <Typography
                    sx={{
                      color: "#808191",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      letterSpacing: "0.03em",
                      textTransform: "uppercase",
                      mb: 0.5,
                    }}
                  >
                    {field.label}
                  </Typography>
                  <Box
                    sx={{
                      color: "#11142D",
                      fontSize: "0.925rem",
                      lineHeight: 1.5,
                      wordBreak: "break-word",
                    }}
                  >
                    {renderValue(field.value)}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}

          {footer ? (
            <>
              <Divider />
              <Box>{footer}</Box>
            </>
          ) : null}

          {actions ? (
            <>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {actions}
              </Box>
            </>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
}
